export default "__VITE_ASSET__BzqCfo_4__"